import React from 'react'
import { pt } from 'common-data/proptypehelpers'
import _ from 'common-tools/LodashHelper'
import { IdHelper } from 'common-tools/IdHelper'
import { CircleButton } from './CircleButton'
import { FieldArray } from 'redux-form'
import styles from './CollectionBox.less'
import { FormBoxContext } from './FormBoxContext'
import { componentGetCompareProps } from 'common-tools/index'
import { Grid } from './Grid'
import { GridCell } from './GridCell'

class CollectionBoxClass extends React.Component {
  static contextType = FormBoxContext
  static propTypes = {
    fields: pt.array.isRequired,
    children: pt.func.isRequired,
    name: pt.string,
    keyFieldName: pt.string,
    manualKeyFieldValue: pt.bool,
    onAdd: pt.func,
    hideAdd: pt.bool,
    hideDelete: pt.bool,
    showDivider: pt.bool
  }

  static defaultProps = {
    keyFieldName: '_key',
    hideAdd: false,
    hideDelete: false,
    showDivider: false,
    manualKeyFieldValue: false
  }

  componentDidMount () {
    const { fields, autoGen, manualKeyFieldValue, keyFieldName } = this.props
    if (autoGen) {
      let newMember = {}
      let i = 0
      while (i < autoGen) {
        if (!manualKeyFieldValue) {
          newMember[keyFieldName] = IdHelper.uuId()
        }
        fields.push(newMember)
        i++
      }
    }
  }
  componentDidUpdate (prevProps) {
    const { fields, manualKeyFieldValue, keyFieldName } = this.props
    const checkAutoGen = componentGetCompareProps('autoGen', this.props, prevProps, '')
    if (checkAutoGen.HasChanged) {
      let newMember = {}
      let i = 0
      while (i < checkAutoGen.Current) {
        if (!manualKeyFieldValue) {
          newMember[keyFieldName] = IdHelper.uuId()
        }
        fields.push(newMember)
        i++
      }
    }
  }
  onAddClick () {
    const { fields, onAdd, keyFieldName, manualKeyFieldValue } = this.props
    if (_.isFunction(onAdd)) {
      let newMember = {}
      if (!manualKeyFieldValue) {
        newMember[keyFieldName] = IdHelper.uuId()
      }
      newMember = onAdd(newMember)
      fields.push(newMember)
    } else {
      let newMember = {}
      if (!manualKeyFieldValue) {
        newMember[keyFieldName] = IdHelper.uuId()
      }
      fields.push(newMember)
    }
  }

  onDeleteClick (index) {
    const { fields } = this.props
    fields.remove(index)
  }

  render () {
    const { 'data-tid': testId = '', keyFieldName, fields = [], children, hideAdd, hideDelete, showDivider, meta, noLayout } = this.props
    const { debugMode = false } = this.context

    let rows = []
    let errorMessage = meta.error

    const lastIndex = (fields.length || 0) - 1
    // get a row for each existing collection member
    fields.forEach((member, index, fields) => {
      const memberFields = children(member, index, fields)
      const memberKey = _.get(fields.get(index) || {}, keyFieldName, index)
      rows.push(
        <Grid key={memberKey} paddingX>
          <GridCell large={11}>
            {memberFields}
          </GridCell>
          {noLayout || hideDelete
            ? null
            : <GridCell large={1} className={styles.actions} >
              <CircleButton data-tid={`${testId}_${index}_delete`} icon='times' size='sm' color='danger' onClick={this.onDeleteClick.bind(this, index)} />
            </GridCell>
          }
        </Grid>
      )
      if (showDivider === true & index !== lastIndex & noLayout) {
        if (memberFields.skipDivider !== true) {
          rows.push(<hr key={`${memberKey}_Divider`} />)
        }
      }
    })

    if (!hideAdd) {
      rows.push(
        <Grid key={`${fields.name}Add`} paddingX>
          <GridCell>
            <CircleButton data-tid={`${testId}_add`} size='sm' icon='plus' color='success' onClick={this.onAddClick} />
          </GridCell>
        </Grid>
      )
    }

    if (debugMode === true) {
      rows.push(
        <Grid key={`${fields.name}Debug`}>
          <GridCell small={12} medium={12} large={12}>
            <small className='form-text text-info'>Collection: {fields.name}</small>
          </GridCell>
        </Grid>
      )
    }

    if (errorMessage) {
      rows.push(
        <Grid key={`${fields.name}Error`}>
          <GridCell small={12} medium={12} large={12}>
            <div className={styles.errorMessage}>
              {errorMessage}
            </div>
          </GridCell>
        </Grid>
      )
    }

    return rows
  }
}

export const CollectionBox = (props) => { return <FieldArray name={props.name} {...props} component={CollectionBoxClass} /> } // eslint-disable-line
export default CollectionBox
